import React, { useState } from "react";
import { checkApi } from "../Authentication/AxiosInstance";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT; // e.g., "https://college-avenue.com/api"

const FeedbackForm = ({ name, setName, email, setEmail, profession, setProfession, message, setMessage, handleSubmit, feedbackMessage }) => {
    return (
      <div className="w-full items-start h-full">
          <div className="flex flex-col w-full h-full">
            <form className="flex flex-col gap-y-4 w-full" onSubmit={handleSubmit}>
              <input 
                className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-300 rounded-lg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 transition-all" 
                type="text" 
                placeholder="Name" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
                required 
              />
              <input 
                className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-300 rounded-lg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 transition-all" 
                type="email" 
                placeholder="Email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
              <input 
                className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-300 rounded-lg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 transition-all" 
                type="text" 
                placeholder="Student/Others (Please specify)" 
                value={profession} 
                onChange={(e) => setProfession(e.target.value)} 
                required 
              />
              <textarea 
                className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-300 rounded-lg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 transition-all resize-y min-h-[120px]" 
                rows="7" 
                placeholder="Message" 
                value={message} 
                onChange={(e) => setMessage(e.target.value)} 
                required 
              />
              <button 
                className="w-full sm:w-auto px-6 py-3 mt-2
                          bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                          border-2 border-primary-900 rounded-lg 
                          text-sm sm:text-base font-bold tracking-widest normal-case
                          transition-all duration-200 shadow-sm hover:shadow-md"
                type="submit">
                Send Message
              </button>
              {/* Show Feedback Message */}
              {feedbackMessage && (
                <div className={`mt-4 p-4 rounded-lg ${
                  feedbackMessage.includes("Thank you") 
                    ? "bg-emerald-50 border-2 border-emerald-200 text-emerald-900" 
                    : "bg-red-50 border-2 border-red-200 text-red-900"
                }`}>
                  <p className="text-sm sm:text-base font-medium">
                    {feedbackMessage}
                  </p>
                </div>
              )}
            </form>
          </div>
      </div>
    );
};
export const ContactUs = () => {
    console.log ('starting from contact')
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [profession, setProfession] = useState("");
    const [message, setMessage] = useState("");
    const [feedbackMessage, setFeedbackMessage] = useState(""); // state for success message

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
        // await axios.post(`${API_ENDPOINT}/send-email/`, { name, email, profession, message });
        console.log(name, email, profession, message)
        await checkApi.post(`${API_ENDPOINT}/feedback/`, { name, email, profession, message });
        setFeedbackMessage("Thank you for sharing your thoughts with us. Your message has been saved. We will reach out to you if we have any queries.");
        setName("");
        setEmail("");
        setProfession("");
        setMessage("");
        } catch (error) {
          let errorMessage = "Failed to send message. Please try again.";
          if (error.response) {
              if (error.response.data) {
                  errorMessage += ` Details: ${JSON.stringify(error.response.data)}`;
              }
          }

          // Show error message
          setFeedbackMessage(errorMessage);
        }
    };
    
    return (
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 lg:gap-12 items-start">
          {/* Content Section */}
          <div className="flex flex-col w-full md:w-1/2">
            <div className="font-light text-primary-700 tracking-wide">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-900 mb-4 sm:mb-6">Get in Touch!</h1>
              <p className="leading-relaxed text-base sm:text-lg md:text-xl font-light tracking-wide mb-6 sm:mb-8">
                We are continually striving to enhance <span className="font-bold text-primary-900">College Avenue</span> and provide the best possible experience for our users. Your <span className="font-bold text-primary-900">feedback is invaluable</span> in helping us serve you better.
              </p>
            </div>
            <div className="font-light text-primary-700 tracking-wide">
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary-900 mt-6 sm:mt-8 mb-3 sm:mb-4">For Students</h1>
              <p className="leading-relaxed text-base sm:text-lg md:text-xl font-light tracking-wide mb-3 sm:mb-4">
                If you have any suggestions or ideas for new features, we'd love to hear from you.
              </p>
              <p className="leading-relaxed text-base sm:text-lg md:text-xl font-light tracking-wide">
                Your insights will <span className="font-bold text-primary-900">directly shape the future</span> of College Avenue and help us create the <span className="font-bold text-primary-900">ultimate resource</span> for students navigating the college admissions process.
              </p>
            </div>
          </div>
          
          {/* Form Section */}
          <div className="w-full md:w-1/2 mt-6 md:mt-0">
            <FeedbackForm 
              name={name} setName={setName}
              email={email} setEmail={setEmail}
              profession={profession} setProfession={setProfession}
              message={message} setMessage={setMessage}
              handleSubmit={handleSubmit}
              feedbackMessage={feedbackMessage}
            />
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="font-light text-primary-700 tracking-wide mt-8 sm:mt-12 md:mt-16">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary-900 mb-4 sm:mb-6">For Organizations, Professionals & Researchers</h1>
          <p className="leading-relaxed text-base sm:text-lg md:text-xl font-light tracking-wide mb-4 sm:mb-6">
            <span className="font-bold text-primary-900">We are exploring ways to generate valuable reports, insights, and trends from our data. </span> 
            If you are interested in <span className="font-bold text-primary-900">data-driven insights</span>, let's discuss how we can help. 
            <span className="font-bold text-primary-900"> Your input will help shape our future reports and analytics! </span>
          </p>
          <p className="leading-relaxed text-base sm:text-lg md:text-xl font-light tracking-wide">
            Thank you for helping us make <span className="font-bold text-primary-900">College Avenue </span> 
            a valuable resource for students navigating the college admissions process. 
            <span className="font-bold text-primary-900">We look forward to hearing from you!</span>
          </p>
        </div>
      </div>
    );
};


